import { getYear } from './getYear/getYear';
import { getMediumDate } from './getMediumDate/getMediumDate';
import { getLongDate } from './getLongDate/getLongDate';
import { getLongTime } from './getLongTime/getLongTime';
import { getShortDate } from './getShortDate/getShortDate';
import { getShortTime } from './getShortTime/getShortTime';
export const dateTimeFormat = {
    getShortDate,
    getMediumDate,
    getLongDate,
    getShortTime,
    getLongTime,
    getYear,
};
//# sourceMappingURL=dateTimeFormat.js.map